export var LTRPopperPlacements = {
    end: 'right',
    'end-top': 'right-start',
    'end-bottom': 'right-end',
    start: 'left',
    'start-top': 'left-start',
    'start-bottom': 'left-end'
};
export var RTLPopperPlacements = {
    auto: undefined,
    'auto-start': 'right',
    'auto-end': 'left',
    top: 'top',
    'top-start': 'top-end',
    'top-end': 'top-start',
    end: 'left',
    'end-top': 'left-start',
    'end-bottom': 'left-end',
    bottom: 'bottom',
    'bottom-start': 'bottom-end',
    'bottom-end': 'bottom-start',
    start: 'right',
    'start-top': 'right-start',
    'start-bottom': 'right-end',
    right: 'left',
    'right-start': 'left-start',
    'right-end': 'left-end',
    left: 'right',
    'left-start': 'right-start',
    'left-end': 'right-end'
};
var isKeyOfPlacementMap = function(key) {
    return LTRPopperPlacements.hasOwnProperty(key);
};
export function usePlacement(placement, isRtl) {
    var normalizedPlacement = isKeyOfPlacementMap(placement) ? LTRPopperPlacements[placement] : placement;
    return isRtl ? RTLPopperPlacements[normalizedPlacement] : normalizedPlacement;
}
export default usePlacement;
